<template>
  <div class="percent-bar-root">
    <div class="bar-container">
      <div class="bar-base"></div>
      <div class="bar-main" :style="{ width: barData.barMainWidth }">
        <!-- :style="{ width: `${barData.barPercent}%` }" -->
        <div class="bar-progress" :style="{ width: `${barData.barPercent}%` }">
          <div class="bar-tips-progress">
            <div class="tips-progress-body">{{ thousandthDigit(percentCount) }}</div>
            <img class="tips-progress-arrow" src="@/assets/packageAssets/views/P2_Page/Invite/default/arrow-bar.webp" alt="" />
          </div>
        </div>
      </div>
      <!-- 节点0 -->
      <div class="bar-step-bg0"></div>
      <div class="bar-step0">
        <div class="tips-root">
          <div class="bar-tips0">
            <div v-if="barData.tips0Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips0Percent }}</span>
            </div>
            <div class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips0Value }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 节点1 -->
      <div v-if="barData.step1Show" class="bar-step-bg1"></div>
      <div v-if="barData.step1Show" class="bar-step1">
        <div class="tips-root">
          <div class="bar-tips1">
            <div v-if="barData.tips1Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips1Percent }}</span>
            </div>
            <div class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips1Value }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 节点2 -->
      <div v-if="barData.step2Show" class="bar-step-bg2"></div>
      <div v-if="barData.step2Show" class="bar-step2"></div>
      <!-- 节点3 -->
      <div class="bar-step-bg3"></div>
      <div class="bar-step3">
        <div class="tips-root">
          <div class="bar-tips3">
            <div v-if="barData.tips3Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips3Percent }}</span>
            </div>
            <div v-if="barData.tips3Value" class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips3Value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentCount: {
      type: Number,
      default: 0,
    },
    earnTypeList: {
      type: Array,
      default() {
        return [
          // {
          //   minBeans: 0,
          //   levelRate: 5
          // },
          // {
          //   minBeans: 10000,
          //   levelRate: 8
          // },
          // {
          //   minBeans: 10000000,
          //   levelRate: 30
          // }
        ]
      },
    },
  },
  data() {
    return {
      barData: {
        // 第一阶段宽度
        barMainWidth: '0%',
        // 进度条
        barPercent: '0%',
        // 总共有4个节点，最少显示两个，最多4个
        step1Show: true,
        step2Show: true,
        tips0Value: '0',
        tips0Percent: '5%',
        tips1Value: '',
        tips1Percent: '',
        tips3Value: '',
        tips3Percent: '30%',
        icon3: false,
      },
    }
  },
  watch: {
    earnTypeList: {
      handler() {
        const copyArr = this.earnTypeList.slice()
        const realEarnTypeList = []
        copyArr.forEach((ele) => {
          if (!realEarnTypeList.some((item) => ele.minBeans === item.minBeans && ele.levelRate === item.levelRate)) {
            realEarnTypeList.push(ele)
          }
        })

        if (realEarnTypeList.length) {
          let baseCount = 1
          if (realEarnTypeList.length < 2) {
            baseCount = realEarnTypeList[0].minBeans
          }
          if (realEarnTypeList.length >= 2) {
            baseCount = realEarnTypeList[1].minBeans - realEarnTypeList[0].minBeans
          }

          const targetCount = this.percentCount - realEarnTypeList[0].minBeans

          const percentRes = (targetCount / baseCount) * 100

          if (percentRes === 0) {
            this.barData.barPercent = 0
          }
          // > 100%
          else if (percentRes >= 100) {
            this.barData.barPercent = 100
          }
          // < 10%  > 0%
          else if (percentRes > 0 && percentRes < 10) {
            this.barData.barPercent = 10
          }
          // > 10%
          else {
            this.barData.barPercent = percentRes
          }

          switch (realEarnTypeList.length) {
            case 1:
              this.barData.barMainWidth = '100%'
              this.barData.step1Show = false
              this.barData.step2Show = false
              this.barData.tips0Value = this.thousandthDigit(realEarnTypeList[0].minBeans)
              this.barData.tips0Percent = `${realEarnTypeList[0].levelRate}%`
              this.barData.tips3Value = this.thousandthDigit(realEarnTypeList[0].maxBeans)
              this.barData.tips3Percent = ''
              this.barData.icon3 = true
              break
            case 2:
              this.barData.barMainWidth = '100%'
              this.barData.step1Show = false
              this.barData.step2Show = false
              this.barData.tips0Value = this.thousandthDigit(realEarnTypeList[0].minBeans)
              this.barData.tips0Percent = `${realEarnTypeList[0].levelRate}%`
              this.barData.tips3Value = this.thousandthDigit(realEarnTypeList[1].minBeans)
              this.barData.tips3Percent = realEarnTypeList[1].level ? `${realEarnTypeList[1].levelRate}%` : ''
              this.barData.icon3 = true
              break
            case 3:
              this.barData.barMainWidth = '58%'
              this.barData.step2Show = false
              this.barData.tips0Value = this.thousandthDigit(realEarnTypeList[0].minBeans)
              this.barData.tips0Percent = `${realEarnTypeList[0].levelRate}%`
              this.barData.tips1Value = this.thousandthDigit(realEarnTypeList[1].minBeans)
              this.barData.tips1Percent = `${realEarnTypeList[1].levelRate}%`
              this.barData.tips3Value = this.thousandthDigit(realEarnTypeList[2].minBeans)
              this.barData.tips3Percent = `${realEarnTypeList[2].levelRate}%`
              this.barData.icon3 = false
              break
            case 4:
              this.barData.barMainWidth = '58%'
              this.barData.step1Show = true
              this.barData.step2Show = true
              this.barData.tips0Value = this.thousandthDigit(realEarnTypeList[0].minBeans)
              this.barData.tips0Percent = `${realEarnTypeList[0].levelRate}%`
              this.barData.tips1Value = this.thousandthDigit(realEarnTypeList[1].minBeans)
              this.barData.tips1Percent = `${realEarnTypeList[1].levelRate}%`
              this.barData.tips3Value = this.thousandthDigit(realEarnTypeList[3].minBeans)
              this.barData.tips3Percent = `${realEarnTypeList[3].levelRate}%`
              this.barData.icon3 = false
              break
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
$step-size: 12px;
$step-border: 2.5px;
$step-inner: $step-size - $step-border * 2;

.percent-bar-root {
  width: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;

  .bar-container {
    width: 100%;
    min-height: 12px;
    position: relative;
    display: flex;
    align-items: center;

    .bar-base {
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 4px;
      background: #e7e7e9;
      border-radius: 7px;
      transform: translateY(-50%);
      z-index: 2;
    }

    .bar-main {
      position: relative;
      width: 58%;
      z-index: 3;

      .bar-progress {
        height: 4px;
        background: #e6a772;
        border-radius: 7px;
        position: relative;
        .bar-tips-progress {
          position: absolute;
          right: 0;
          transform: translateX(50%);
          bottom: calc(100% + 6px);
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 5;
          pointer-events: none;
          white-space: nowrap;
          transform-origin: center bottom;

          .tips-progress-body {
            min-width: 30px;
            padding: 2px 8px;
            background: #f89e53;
            border-radius: 100px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-label-16);
            text-align: center;
            color: #ffffff;
          }

          .tips-progress-arrow {
            width: 20px;
            height: 7px;
            margin-top: -1px;
            display: block;
          }
        }
      }
    }

    .bar-step-bg0,
    .bar-step-bg1,
    .bar-step-bg2,
    .bar-step-bg3 {
      box-sizing: border-box;
      width: $step-size;
      height: $step-size;
      border-radius: 50%;
      background-color: #ebe5dd;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    .bar-step0,
    .bar-step1,
    .bar-step2,
    .bar-step3 {
      box-sizing: border-box;
      width: $step-inner;
      height: $step-inner;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 4;

      .tips-root {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: visible;
      }

      .bar-tips0,
      .bar-tips1,
      .bar-tips3 {
        position: absolute;
        bottom: -38px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: visible;
        white-space: nowrap;

        .tips-row {
          display: inline-flex;
          align-items: center;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-12);
          line-height: var(--lh-label-16);
          color: #666666;
        }

        .tips-row-value {
          min-height: 14px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-10);
          line-height: var(--lh-label-14);
          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
            flex-shrink: 0;
          }
        }
      }

      .bar-tips0 {
        left: -3px;
      }
      .bar-tips1 {
        width: 118px;
        left: 50%;
        align-items: center;
        margin-left: -59px;
      }
      .bar-tips3 {
        right: 0;
        align-items: flex-end;
      }
    }

    .bar-step-bg0 {
      left: -$step-border;
    }

    .bar-step0 {
      background-color: #e6a772;
      left: 0;
    }

    .bar-step-bg1 {
      left: calc(58% - 10px);
    }

    .bar-step1 {
      background-color: #e6a772;
      left: calc(58% - 10px + #{$step-border});
    }

    .bar-step-bg2 {
      left: 79%;
    }

    .bar-step2 {
      width: $step-inner;
      height: $step-inner;
      background-color: #c7b9a6;
      left: calc(79% + #{$step-border});
    }

    .bar-step-bg3 {
      left: calc(100% - 10px);
    }

    .bar-step3 {
      background-color: #e6a772;
      left: calc(100% - 10px + #{$step-border});
    }
  }
}

$step-offset: 10px;
$step1-position: 58%;
$step2-position: 79%;

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .percent-bar-root {
    .bar-container {
      overflow: visible;

      .bar-main {
        overflow: visible;

        .bar-progress {
          .bar-tips-progress {
            right: auto;
            left: 0;
            transform: translateX(-50%);
          }
        }
      }
      .bar-step-bg1,
      .bar-step-bg2,
      .bar-step-bg3,
      .bar-step0,
      .bar-step1,
      .bar-step2,
      .bar-step3 {
        .bar-tips0,
        .bar-tips1,
        .bar-tips3 {
          .tips-row-value img {
            margin-right: 0;
            margin-left: 4px;
          }
        }

        .bar-tips0 {
          right: -3px;
          left: auto;
        }

        .bar-tips1 {
          right: 50%;
          left: auto;
          margin-right: -59px;
          margin-left: auto;
        }

        .bar-tips3 {
          right: auto;
          left: 0;
        }
      }

      .bar-step-bg0,
      .bar-step0 {
        right: -$step-border;
        left: auto;
      }

      .bar-step0 {
        right: 0;
      }

      .bar-step-bg1,
      .bar-step1 {
        right: calc(#{$step1-position} - #{$step-offset});
        left: auto;
      }

      .bar-step1 {
        right: calc(#{$step1-position} - #{$step-offset} + #{$step-border});
      }

      .bar-step-bg2,
      .bar-step2 {
        right: $step2-position;
        left: auto;
      }

      .bar-step2 {
        right: calc(#{$step2-position} + #{$step-border});
      }

      .bar-step-bg3,
      .bar-step3 {
        right: calc(100% - #{$step-offset});
        left: auto;
      }

      .bar-step3 {
        right: calc(100% - #{$step-offset} + #{$step-border});
      }
    }
  }
}
</style>
